import { FileModel, IFile } from './file.model';
import { ITemplateField, TemplateFieldModel } from './template-field.model';

export interface ITemplate {
  templateId: string;
  code: string;
  name: string;
  description: string;
  fileId: string | null;
  generateQr: boolean;
  status: boolean;
  uidCreatedBy: string | null;
  uidUpdatedBy: string | null;
  createdAt: string;
  updatedAt: string;
  image?: IFile | null;
  fields?: ITemplateField[];
}

export class TemplateModel {
  templateId: string;
  code: string;
  name: string;
  description: string;
  fileId: string | null;
  generateQr: boolean;
  status: boolean;
  uidCreatedBy: string | null;
  uidUpdatedBy: string | null;
  createdAt: Date;
  updatedAt: Date;
  image: FileModel | null;
  fields: TemplateFieldModel[];

  constructor(data: ITemplate) {
    this.templateId = data.templateId;
    this.code = data.code;
    this.name = data.name;
    this.description = data.description;
    this.fileId = data.fileId ?? null;
    this.generateQr = data.generateQr;
    this.status = data.status;
    this.uidCreatedBy = data.uidCreatedBy ?? null;
    this.uidUpdatedBy = data.uidUpdatedBy ?? null;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
    this.image = data.image ? new FileModel(data.image) : null;
    this.fields = (data.fields ?? []).map((field) => new TemplateFieldModel(field));
  }
}
